<template>
    <div class="app"></div>
</template>

<script>
    import util from '@/libs/util.js';

    export default {
        name: "page-monitor",
        data() {
            return {
                token: "",
            }
        },
        methods: {},
        mounted: function () {
            this.token = decodeURIComponent(this.$route.query.token);
            if (this.token) {
                localStorage.setItem('token', this.token);
                util.getAuth(1).then(_ => {
                    this.$router.push({
                        name: 'm_home'
                    });
                });
            }
        },
    }
</script>
<style scoped>
</style>